import { NavigateFunction } from 'react-router-dom';

export const navigateFromRow = (
  id: number,
  role: string | undefined,
  status: string,
  erpId: string | null,
  navigate: NavigateFunction,
  fromAdmin: boolean | void
): void | null => {
  const adminRoute = fromAdmin ? '/admin' : '';
  switch (status) {
    case 'DRAFT':
      navigate(`${adminRoute}/ferdabeidnir/ferdabeidni?id=${id}`);
      break;
    case 'PENDING':
    case 'DENIED':
    case 'COST_APPROVED':
      navigate(
        `${adminRoute}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni`,
        {
          state: { hasActions: !!role, role, erpId },
        }
      );
      break;
    case 'AUTHORIZED':
    case 'COST_REVISIT':
      navigate(
        `${adminRoute}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=kostnadur`,
        {
          state: { hasActions: true, erpId },
        }
      );
      break;
    case 'COST_IN_REVIEW':
    case 'COST_REVIEWED':
      navigate(
        `${adminRoute}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni`,
        {
          state: { hasActions: true, erpId },
        }
      );
      break;
    case 'COST_CONFIRMED':
      navigate(
        `${adminRoute}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni`,
        {
          state: { hasActions: !!role, role, erpId },
        }
      );
      break;
    case 'COMPLETED':
      navigate(
        `${adminRoute}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni`,
        {
          state: { hasActions: false, erpId },
        }
      );
      break;
    default:
      return null;
  }
};
